import React, { useEffect, useState } from "react";
import FormSectionTitle from "../FormSectionTitle";
import { useTranslation } from "react-i18next";
import Checkbox from "../Checkbox";
import Button from "../Button";
import { useMutation, useQuery } from "react-query";
import {
  fetchRateSingleLocalBkengine,
  pickRatePlanBkEngine,
} from "../../shared/queries";
import { toast } from "react-toastify";
import BkService from "./components/BkService";

type Props = {
  id: string;
};

const BkRate = (props: Props) => {
  const { id } = props;
  const { t } = useTranslation();
  const [rateId, setRateId] = useState("");
  const [chargeGuest, setChargeGuest] = useState<boolean>(false);

  const {
    data: rateList,
    refetch: refetchRateList,
    isLoading: isLoadingRateList,
  } = useQuery<any>(
    ["channelmanagerrate", id],
    () => fetchRateSingleLocalBkengine(id as string),
    { enabled: !!id }
  );

  const pickRatePlanBkEngineMutation = useMutation(
    (body: { local_key: string; rate_plan_id: string; charge_guest_commission: boolean}) =>
      pickRatePlanBkEngine(body),
    {
      onSuccess: () => {
        toast.success(t("general.fileUploaded"));
        refetchRateList();
      },
      onError: (error: Error) => {
        toast.error(t(error?.message ? error.message : "general.requestError"));
        refetchRateList();
      },
    }
  );

  useEffect(() => {
    if (rateList) {
      rateList?.results?.forEach((rate: any) => {
        if (rate.flg_bkengine) {
          setRateId(rate.id);
          setChargeGuest(rate.charge_guest_commission);
        }
      });
    }
  }, [rateList]);

  return (
    <>
      <FormSectionTitle
        title={t("apartmentContent.ratePlanBkEngine")}
        onEdit={() => {}}
      ></FormSectionTitle>
      <div className="flex-row  md:text-sm text-xs">
        {rateList?.results?.map((rate: any) => (
          <div className={`
          group cursor-pointer lg:w-1/2 w-full mt-4 mb-4 p-4
          border
          rounded-2xl bg-white
          transition-all duration-200 ease-in-out
          hover:border-cyan-600
          ${rateId === rate.id ? 'border-cyan-600 ring-1 ring-cyan-600' : 'border-grey-200'}`}>
            <>
            <Checkbox
              disabled={rateId === rate.id}
              checked={rateId === rate.id}
              onChange={() => {
                setRateId(rate.id);
                setChargeGuest(false);
              }}
              label={rate.attributes.title}
              size="md"
            />
            {console.log(rate.charge_guest_commission)}
            {rateId === rate.id && (
                <div className="ml-8">
                <Checkbox
                  className="max-w-max"
                  label={t("apartmentContent.chargeGuestCommissionBkengine")}
                  checked={chargeGuest}
                  onChange={() => setChargeGuest(!chargeGuest)}
                />
              </div>
            )}
            </>
          </div>
        ))}
      </div>
      <div className="my-3">
        <Button
          label={t("general.save")}
          disabled={isLoadingRateList || pickRatePlanBkEngineMutation.isLoading}
          loading={isLoadingRateList || pickRatePlanBkEngineMutation.isLoading}
          onClick={() => {
            pickRatePlanBkEngineMutation.mutate({
              local_key: id as string,
              rate_plan_id: rateId as string,
              charge_guest_commission: chargeGuest as boolean,
            });
          }}
        />
      </div>
      <BkService local_key={id} />
    </>
  );
};

export default BkRate;
